/** @format */
import CustomSelect from '../../v2-components/Antd/Select';
import { filterSort } from './handle/filter-sort.handle';

export default function Pharmacies(props) {
	return (
		<>
			<CustomSelect
				{...props}
				showSearch
				bordered={true}
				placeholder={props.placeholder ?? "Seleccione una farmacia"}
				options={props.options}
				onChange={props.onChange}
				optionFilterProp="children"
				filterOption={(input, option) => (option?.label ?? '').includes(input)}
				filterSort={(optionA, optionB) => filterSort(optionA, optionB)}
			/>
		</>
	);
}
